/* es5-ext/number/is-integer/implement.js */ function _(require, module, exports) {
    if (!require(12) /* ./is-implemented */()) {
        Object.defineProperty(Number, "isInteger", {
            value: require(13) /* ./shim */,
            configurable: true,
            enumerable: false,
            writable: true
        });
    }
}
